import { ClientAvatarType } from "@prisma/client";
import { CSSProperties } from "react";
import { computeInitials } from "../Avatars.logic";
import styles from "../Avatars.module.css";

type Props = {
  name: string;
  large?: boolean;
  type?: ClientAvatarType;
};

export default function AvatarInitials(props: Props) {
  const { name, large, type } = props;

  let style: CSSProperties = {};
  if (type === ClientAvatarType.SECONDARY) {
    style = {
      background: "var(--color-avatar-secondary-bg)",
      color: "var(--color-avatar-secondary)",
    };
  } else if (type === ClientAvatarType.EXPLORATORY) {
    style = {
      background: "var(--color-avatar-exploratory-bg)",
      color: "var(--color-avatar-exploratory)",
    };
  }

  return (
    <div className={large ? styles.initialsLarge : styles.initials} style={style}>
      {computeInitials(name)}
    </div>
  );
}
